import React, { useState } from 'react'
import AdminLogin from './AdminLogin';

const Home = () => {

  return (
    <div className='bgcolor2 h-screen'>
      <AdminLogin />
    </div>
  )
}

export default Home
